import { DynamicScriptLoaderService } from './dynamic-script-loader.service';
import { environment } from '@environments/environment';

export function scriptLoaderFactory(scriptLoader: DynamicScriptLoaderService) {
  return () => {
    return scriptLoader.loadScript(environment.dynatraceScriptUrl).catch(() => {
      return;
    });
  };
}
